module.exports = __webpack_public_path__ + "img/LV40003074764.2eb1e1bf.png";